import Vue from 'vue';

const success = (data, resolve) => {
  resolve(data);
};

const failed = (errors, reject) => {
  reject(errors);
};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('account/subscription')
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);




// WEBPACK FOOTER //
// ./src/app/services/account/subscription.js